export const api = {
  COMMUNITIES: '/btr-api/communities',
  ENUMERATION: '/enumerations',
};
